/* eslint-disable react/prop-types */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/anchor-is-valid */

import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import RRuleGenerator from 'react-rrule-generator';

import {
  AttachMoney,
  Close,
  Edit,
  MoneyOff,
  OpenInNew,
  Receipt,
} from '@mui/icons-material';
import {
  Alert,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Switch,
  useColorScheme,
  useMediaQuery,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { patchEvent } from '@pingum/app-state-management/event/actions';
import { capitalize } from 'lodash';
import { rrulestr } from 'rrule';
import BarnHorsesAutocomplete from '../../../../components/Autocompletes/BarnHorses';
import BarnUsersAutocomplete from '../../../../components/Autocompletes/BarnUsers';
import BillableStatusSelect from '../../../../components/EnumSelects/BillableStatusSelect';

import TaskDefinitionAutocomplete from '../../../../components/Autocompletes/TaskDefinition';
import Horse from '../../../../components/Horse';
import Property from '../../../../components/Property';
import {
  getBillableForTask,
  setGlobalModals,
} from '../../../../redux/app/actions';
import { TASK_MODAL_TYPE } from '../../../../redux/app/types';
import {
  addBillable,
  deleteBillable,
  getInvoicesForBillable,
  updateBillable,
} from '../../../../redux/billables/actions';
import {
  blueGrey,
  primary,
} from '../../../../utils/brandColors';
import {
  fromPickerValue,
  toMomentValue,
} from '../../../../utils/dateHelper';
import {
  BILLABLE_PRICE_ERROR,
  isBillablePriceInput,
  isValidBillablePrice,
} from '../../../../utils/billablePrice';
import theme from '../../../../utils/theme';
import AddEditInvoiceModalComponent from '../Invoices/components/AddEditInvoice';
import { canManageQuickBooks } from '../../../../utils/quickbooks';
import { isQuickBooksAvailable } from '../../../../utils/quickbooksAvailability';
import {
  isQuickBooksReserved,
  quickBooksExportPath,
  quickBooksReservationMessage,
} from '../../../../utils/quickBooksReservation';

const AddEditBillableModalComponent = ({
  open,
  onClose,
  billable,
  billableDate: billableDateProp,
  billableDescription,
  billableTaskTypeId,
  horses,
  task,
  horseId,
  disableHorseTaskLookup = false,
  repeatMode: propRepeatMode, // when true only show repeat
}) => {
  const dispatch = useDispatch();
  const fullscreen = useMediaQuery(theme.breakpoints.down('md'));
  const { mode } = useColorScheme();
  // Redux
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const permissions = useSelector((state) => state.user.permissions);
  const quickBooksReserved = isQuickBooksReserved(billable);
  const canViewExport = quickBooksReserved && canManageQuickBooks(permissions)
    && isQuickBooksAvailable(selectedBarn?.tenant, env.REACT_APP_DOMAIN);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const isUpdatingBillable = useSelector((state) => state.billables.isUpdatingBillable);
  const isAddingBillable = useSelector((state) => state.billables.isAddingBillable);
  const billableForTask = useSelector((state) => state.app.billableForTask);
  const billableInvoices = useSelector((state) => state.billables.billableInvoices);
  const allEventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const eventData = useSelector((state) => state.eventData.eventData);
  // const isFetchingBillableInvoices = useSelector((state) => state.billables.isFetchingBillableInvoices);
  const isLoading = isUpdatingBillable || isAddingBillable;

  // form fields
  const [repeatMode, setRepeatMode] = React.useState(propRepeatMode);
  let title = billable
    ? 'Edit Transaction'
    : 'Add Transaction';
  if (repeatMode) {
    title = billable
      ? 'Edit Repeating Transaction'
      : 'Add Repeating Transaction';
  }
  if (quickBooksReserved) title = 'View Transaction';
  const [status, setStatus] = React.useState('Open');
  const [paymentNote, setPaymentNote] = React.useState('');
  const [note, setNote] = React.useState('');
  const [price, setPrice] = React.useState('');
  const [quantity, setQuantity] = React.useState(null);
  const [receivable, setReceivable] = React.useState('true');
  const [billableDate, setBillableDate] = React.useState(new Date());
  const [barnHorses, setBarnHorses] = React.useState([]);
  const [barnUsers, setBarnUsers] = React.useState([]);
  const [taskTypeId, setTaskTypeId] = React.useState(null);
  const [repeatRrule, setRepeatRrule] = React.useState(null);
  const [repeatEndDate, setRepeatEndDate] = React.useState(null);
  const [loadTaskBillableFailure, setLoadTaskBillableFailure] = React.useState(false);
  const [addingBillableError, setAddingBillableError] = React.useState(null);
  const [validation, setValidation] = React.useState({});
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [splitAmount, setSplitAmount] = React.useState(false);

  const [selectedInvoice, setSelectedInvoice] = React.useState(null)
  const [openAddEditModal, setOpenAddEditModal] = React.useState(false)

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name;

  React.useEffect(() => {
    const repeat = propRepeatMode || repeatMode
    setRepeatMode(repeat);
    setConfirmDelete(false);
    setStatus((billable && billable.status) || 'Open');
    setPaymentNote((billable && billable.paymentNote) || '');
    setNote((repeat && billable && billable.repeatNote) || (billable && billable.note) || billableDescription || '');
    setReceivable(((!billable || !billable.id) && 'true') || (billable && billable.receivable && 'true') || 'false');
    setPrice((repeat && billable && billable.repeatPrice) || (billable && billable.price) || '0.00');
    setQuantity((repeat && billable && billable.repeatQuantity) || (billable && billable.quantity) || null);
    setBillableDate((billable && billable.billableDate) || billableDateProp || moment(new Date()).startOf('day').toDate());
    setBarnHorses((billable && billable.horse && barnHorsesMap[billable.horse.id] && [barnHorsesMap[billable.horse.id][0]])
      || (horseId && barnHorsesMap[horseId] && [barnHorsesMap[horseId][0]]) || null);
    setBarnUsers((repeat && billable && billable.repeatBarnUsers
      && billable.repeatBarnUsers.filter((bu) => barnUsersMap[bu]).map((bu) => barnUsersMap[bu][0])) || (billable && billable.barnUsers) || []);
    setAddingBillableError(null);
    setRepeatRrule((billable && billable.repeatRrule) || null);
    setRepeatEndDate((billable && billable.repeatEndDate) || null);
    setTaskTypeId((repeat && billable && billable.repeatTaskTypeId) || (billable && billable.taskTypeId) || billableTaskTypeId || null);
    setSplitAmount(false);
    setValidation({});
    if (!billable && !!horses) {
      let passedInBarnHorses = [];
      for (let i = 0; i < horses.length; i += 1) {
        if (horses[i] && horses[i].id && barnHorsesMap[horses[i].id] && barnHorsesMap[horses[i].id][0]) {
          passedInBarnHorses = [...passedInBarnHorses, barnHorsesMap[horses[i].id][0]];
        }
      }
      setBarnHorses(passedInBarnHorses);
    }

    if (billable && billable.id) {
      dispatch(getInvoicesForBillable(billable.id));
    }
    setSelectedInvoice(null)
    setOpenAddEditModal(false)
  }, [billable, open, billableForTask, propRepeatMode, repeatMode]);

  const loadBillable = (retry, taskId) => {
    dispatch(getBillableForTask(horseId, taskId)).then((taskBillable) => {
      if ((!taskBillable || !taskBillable.id) && retry < 4) {
        setTimeout(() => {
          loadBillable(retry + 1, taskId);
        }, 3000);
      } else {
        setLoadTaskBillableFailure(true);
      }
    }).catch((error) => {
      console.error(error);
      setLoadTaskBillableFailure(true);
      // Do nothing?
    });
  };

  React.useEffect(() => {
    // If the task is passed in we need to load an associated billable
    if (!billable && task && horseId && !disableHorseTaskLookup) {
      setLoadTaskBillableFailure(false);
      loadBillable(0, task.id); // Try and load the billable, 3 attempts
    }
  }, [task, horseId]);

  const validateFields = () => {
    const updatedValidation = { horse: '' };
    if (!isValidBillablePrice(price)) {
      setAddingBillableError(BILLABLE_PRICE_ERROR);
      return false;
    }
    let isValid = true;
    if (!billable && (!barnHorses || barnHorses.length < 1)) {
      updatedValidation.horse = 'Select at least one horse for this transaction';
      isValid = false;
    }
    if (!note || note.length === 0) {
      updatedValidation.description = 'Provide a transaction description';
      isValid = false;
    }
    setValidation(updatedValidation);
    return isValid;
  };

  const handleUpdateTask = (newPrice, type, updatedBillables) => {
    if (task && task.id) {
      const newEventData = task.eventData;
      if (type === 'DELETE') {
        delete newEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)];
      } else {
        newEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)] = {
          type: 'CurrencyUSD',
          value: `${newPrice}`,
        };
      }
      dispatch(patchEvent(task.id, { eventData: newEventData }));
      onClose(updatedBillables || true, type);
    } else {
      onClose(updatedBillables || false, type);
    }
  };

  const onSave = () => {
    if (quickBooksReserved) return;
    if (!validateFields()) { return; }
    if (!billable && barnHorses.length > 0) {
      const promises = [];
      for (let i = 0; i < barnHorses.length; i += 1) {
        let finalAmount = price || 0;
        if (splitAmount && parseFloat(price, 10) > 0) {
          finalAmount = `${(parseFloat(price, 10) / barnHorses.length).toFixed(2)}`
        }
        promises.push(dispatch(addBillable(barnHorses[i].horse.id, {
          status,
          paymentNote,
          note,
          receivable,
          price: finalAmount,
          quantity,
          billableDate,
          taskTypeId,
          barnUsers: (barnUsers && barnUsers.map((bu) => bu.id)) || [],
          taskId: (task && task.id) || null,
          repeatRrule: repeatRrule
            ? repeatRrule.replace('RRULE:', '')
            : null,
          repeatEndDate,
        })));
      }
      Promise.all(promises).then((newBillables) => {
        setAddingBillableError(false);
        handleUpdateTask(price, 'ADD', newBillables);
      }).catch((error) => {
        setAddingBillableError(error.message || 'There was an error attempting to add the billable. Please contact Questri support.');
        console.error(error);
      })
    } else {
      dispatch(updateBillable(billable.id, {
        repeatMode: !!repeatMode,
        status: status || null,
        paymentNote,
        note,
        receivable,
        price: price || 0,
        quantity,
        billableDate,
        taskTypeId,
        barnUsers: (barnUsers && barnUsers.map((bu) => bu.id)) || [],
        repeatRrule: repeatRrule
          ? repeatRrule.replace('RRULE:', '')
          : null,
        repeatEndDate,
      })).then((updatedBillable) => {
        setAddingBillableError(false);
        handleUpdateTask(price, 'UPDATE', [updatedBillable]);
      }).catch((error) => {
        setAddingBillableError(error.message || 'There was an error attempting to update the billable. Please contact Questri support.');
        console.error(error);
      });
    }
  };

  const handleDelete = () => {
    if (quickBooksReserved) return;
    dispatch(deleteBillable(billable.id)).then(() => {
      setConfirmDelete(false);
      setAddingBillableError(false);
      handleUpdateTask(null, 'DELETE', null);
    }).catch(() => {
      // TODO throw error  messsage
      setAddingBillableError('There was an erroring deleting this billable. Please contact support.');
      setConfirmDelete(false)
    })
  }

  const isRepeating = !!repeatRrule && (!repeatEndDate || new Date(repeatEndDate).getTime() > new Date().getTime())

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="modal-add-billable-title"
      aria-describedby="modal-add-billable-description"
      maxWidth="md"
      PaperProps={{
        sx: {
          m: 0,
          mx: fullscreen
            ? 0
            : 2,
          width: '100%',
          maxWidth: 720,
        },
        onClick: (e) => e.stopPropagation(),
      }}
    >
      <DialogTitle
        sx={{
          background: mode === 'light'
            ? primary.main
            : 'var(--template-palette-background-paper)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >

        <Typography
          id="modal-add-billable-title"
          variant="h4"
          component="span"
          color="#fff"
        >
          {title}
        </Typography>
        <IconButton aria-label="Close transaction" onClick={onClose}><Close sx={{ color: '#fff' }} /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <Divider sx={{ mb: 2 }} />
        {quickBooksReserved && (
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography fontWeight={600}>Reserved for QuickBooks</Typography>
            {quickBooksReservationMessage}
            {canViewExport && (
              <Box sx={{ mt: 1 }}>
                <Button size="small" href={quickBooksExportPath(billable)} endIcon={<OpenInNew />}>View export</Button>
              </Box>
            )}
          </Alert>
        )}
        {
          (task && !billableForTask && !disableHorseTaskLookup)
            ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 2,
                  gap: 2,
                }}
              >
                {
                  !loadTaskBillableFailure
                    ? (
                      <Box>
                        <Typography variant="caption">This may take a moment...</Typography>
                        <Typography variant="subtitle1">Loading transaction for this task</Typography>
                      </Box>
                    )
                    : (
                      <Typography>Unable to load the transaction associated with this task.
                        Please try again in a few minutes by selecting the task and openeing the task page.
                      </Typography>
                    )
                }
                {
                  !loadTaskBillableFailure && (
                    <CircularProgress />
                  )
                }
              </Box>
            )
            : (
              <Grid container spacing={3}>
                {
                  !quickBooksReserved && !repeatMode && billable && billable.repeatNextOccurrenceDate && (
                    <Grid size={12}>
                      <Alert
                        severity="info"
                        action={(
                          <Button startIcon={<Edit />} color="inherit" size="small" onClick={() => setRepeatMode(true)}>
                            Edit Repeating Transaction
                          </Button>
                        )}
                      >
                        This is a repeating Transaction, the next one will be created
                        on {moment((new Date(billable.billableDate).getTime() > new Date().getTime())
                          ? billable.billableDate
                          : billable.repeatNextOccurrenceDate).format('ll')}
                        . Select to modify the
                        repeating transaction rules.
                      </Alert>
                    </Grid>
                  )
                }

                {
                  !quickBooksReserved && repeatMode && billable && (
                    <Grid size={12}>
                      <Alert severity="info">
                        This repeating Transaction has an upcoming occurrence
                        on
                        <b>{' '}{moment((new Date(billable.billableDate).getTime() > new Date().getTime())
                          ? billable.billableDate
                          : billable.repeatNextOccurrenceDate).format('ll')}
                        </b>.
                        You can modify the price, description, transaction category,
                        users, or repeating rules for future occurrences of this Transaction.
                      </Alert>
                    </Grid>
                  )
                }

                {
                  !billable && isRepeating && (
                    <Grid size={12}>
                      <Alert severity="warning">
                        A Transaction will be created for
                        <b>
                          {' '}{moment(billableDate || new Date()).format('ll')}{' '}
                        </b>and will repeat
                        <b>
                          {' '}{`${rrulestr(repeatRrule).toText()}`}{' '}
                        </b>thereafter{repeatEndDate
                          ? ' - ending '
                          : '.'}
                        <b>{' '}{repeatEndDate
                          ? moment(repeatEndDate).format('ll')
                          : ''}
                        </b>
                      </Alert>
                    </Grid>
                  )
                }
                {
                  billable && billable.id && !repeatMode && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Property label="Transaction ID">
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Receipt sx={{ mr: 1 }} color="secondary" />
                          <Box
                            sx={{
                              overflowWrap: 'anywhere',
                              minWidth: 0,
                            }}
                          >
                            {billable.id}
                          </Box>
                        </Box>
                      </Property>
                      {billable.taskId
                        && (
                          <Property label="Associated Task">
                            <Button
                              endIcon={<OpenInNew />}
                              sx={{ p: 0 }}
                              size="small"
                              onClick={(e) => {
                                dispatch(setGlobalModals(TASK_MODAL_TYPE, { id: billable.taskId }, null, null, {}, null));
                                e.stopPropagation();
                                onClose();
                              }}
                            >Task (#{billable.taskId})
                            </Button>
                          </Property>
                        )}
                      {
                        billableInvoices && billableInvoices.length > 0 && (
                          <Property label="Associated Invoice(s)">
                            {
                              billableInvoices.map((i) => (
                                <Box key={`billable-${billable.id}-invoice-${i.id}`}>
                                  <Button
                                    endIcon={<OpenInNew />}
                                    sx={{ p: 0 }}
                                    size="small"
                                    onClick={(e) => {
                                      setSelectedInvoice(i)
                                      setOpenAddEditModal(true)
                                      e.stopPropagation();
                                    }}
                                  >{i.title}
                                  </Button>
                                </Box>
                              ))
                            }
                          </Property>
                        )
                      }
                    </Grid>
                  )
                }

                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  {
                    (billable && barnHorses && barnHorses.length === 1)
                      ? (
                        <Property label="Horse">
                          <Horse showShowName size={40} horse={barnHorses[0].horse} />
                        </Property>
                      )
                      : (
                        <BarnHorsesAutocomplete
                          multiple
                          validation={validation.horse}
                          value={barnHorses || []}
                          size="normal"
                          disabled={!!billable || quickBooksReserved}
                          onSelect={(e, newHorse) => {
                            setBarnHorses(newHorse)
                            if (newHorse.length < 2) {
                              setSplitAmount(false)
                            }
                          }}
                          limitTags={10}
                          label="Horse(s)"
                          helperText="Each horse will receive this billing transaction"
                          showAdornment
                        />
                      )
                  }
                </Grid>
                {
                  !repeatMode && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          label="Date"
                          disabled={quickBooksReserved || isLoading}
                          value={toMomentValue(billableDate)}
                          onChange={(newValue) => {
                            if (newValue && newValue.toDate) {
                              setBillableDate(moment(fromPickerValue(newValue)).startOf('day').toDate());
                            }
                          }}
                          onClick={(e) => { e.stopPropagation(); }}
                          slotProps={{
                            textField: {
                              onClick: (e) => { e.stopPropagation(); },
                              disabled: isLoading || quickBooksReserved,
                              fullWidth: true,
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  )
                }
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    fullWidth
                    id="billable-price"
                    disabled={quickBooksReserved}
                    label="Amount"
                    value={price}
                    error={!isValidBillablePrice(price)}
                    onChange={(e) => {
                      if (e.target.value === '') {
                        setPrice('')
                      } else if (isBillablePriceInput(e.target.value)) {
                        setPrice(e.target.value)
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>),
                      endAdornment: (splitAmount && parseFloat(price, 10) > 0
                        && <InputAdornment position="end">{`$${(parseFloat(price, 10) / barnHorses.length).toFixed(2)} per horse`}</InputAdornment>),
                      inputMode: 'decimal',
                    }}
                    FormHelperTextProps={{ component: 'div' }}
                    helperText={((!billable || !billable.id) && barnHorses && barnHorses.length > 1) && !repeatMode && (
                      <Box sx={{ textAlign: 'right' }}>
                        <Link
                          component="button"
                          variant="body2"
                          color="primary"
                          underline="hover"
                          onClick={() => {
                            setSplitAmount(!splitAmount);
                          }}
                        >
                          {splitAmount
                            ? 'Remove Split Amount'
                            : 'Split Transaction Amount Among Horses'}
                        </Link>
                      </Box>
                    )}
                  />
                  <Box />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    fullWidth
                    id="billable-note"
                    disabled={quickBooksReserved}
                    label="Description"
                    error={validation.description}
                    helperText={(validation && validation.description)}
                    placeholder="Write a description..."
                    value={note}
                    onChange={(e) => { setNote(e.target.value); }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <BarnUsersAutocomplete
                    disabled={quickBooksReserved}
                    multiple
                    value={barnUsers}
                    size="large"
                    onSelect={(e, newBarnUsers) => {
                      setBarnUsers(newBarnUsers)
                    }}
                    limitTags={2}
                    label="User(s)"
                    showAdornment
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TaskDefinitionAutocomplete
                    disabled={quickBooksReserved}
                    value={taskTypeId && (allEventTemplates.find((et) => et.id === taskTypeId) || { id: taskTypeId })}
                    onSelect={(e, value) => { setTaskTypeId((value && value.id) || null); }}
                    label="Transaction Category"
                    placeholder=" "
                    eventTemplates={allEventTemplates}
                    icon
                    helperText="(optional) Transaction category to associate with the Transaction."
                  />
                </Grid>

                <Grid>
                  <TextField
                    id="billable-quantity"
                    disabled={quickBooksReserved}
                    label="Quantity"
                    value={quantity}
                    onChange={(e) => {
                      if (!e.target.value) {
                        setQuantity(null)
                      } else if (/^[0-9]\d*(\.\d+)?$/.test(e.target.value) || e.tartget.value === '-' || e.target.value === '') {
                        setQuantity(e.target.value)
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">#</InputAdornment>),
                      endAdornment: (splitAmount && parseFloat(price, 10) > 0
                        && <InputAdornment position="end">{`$${(parseFloat(price, 10) / barnHorses.length).toFixed(2)} per horse`}</InputAdornment>),
                      inputMode: 'numeric',
                      type: 'number',
                    }}
                    helperText="(optional) quantity or units for transaction"
                  />
                  <Box />
                </Grid>
                <Grid size={12}>
                  <Divider />
                </Grid>
                {
                  !repeatMode && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <FormControl fullWidth margin="none">
                        <InputLabel id="note-type-select-label">Type</InputLabel>
                        <Select
                          disabled={quickBooksReserved}
                          labelId="horse-access-type-select-label"
                          id="horse-access-type-select"
                          value={receivable || 'true'}
                          label="Type"
                          onChange={(e) => {
                            setReceivable(e.target.value);
                            if (e.target.value === 'true') {
                              setStatus('Open')
                            } else {
                              setStatus('Expense')
                            }
                          }}
                        >
                          <MenuItem value="true">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <AttachMoney color="success" sx={{ mr: 1 }} />
                              <Box>Billable</Box>
                            </Box>
                          </MenuItem>
                          <MenuItem value="false">
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <MoneyOff sx={{ mr: 1 }} />
                              <Box>Expense</Box>
                            </Box>
                          </MenuItem>
                        </Select>
                        {!((receivable && receivable !== 'false')) && (
                          <FormHelperText>
                            Expenses have no status and always show as paid out in reporting.
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  )
                }
                {
                  (receivable && receivable !== 'false' && !repeatMode)
                  && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <BillableStatusSelect
                        disabled={quickBooksReserved}
                        value={status || ''}
                        includeExpenseOption={false}
                        onChange={(e) => {
                          setStatus(e.target.value)
                        }}
                      />
                    </Grid>
                  )
                }
                {
                  !repeatMode && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <TextField
                        fullWidth
                        id="payment-note"
                        disabled={quickBooksReserved}
                        placeholder="Write transaction notes here"
                        multiline
                        rows="2"
                        label="Transaction Notes"
                        value={paymentNote}
                        onChange={(e) => { setPaymentNote(e.target.value); }}
                      />
                    </Grid>
                  )
                }

                {
                  addingBillableError && <Grid size={12}><Typography variant="caption" color="error" gutterBottom>{addingBillableError}</Typography></Grid>
                }

              </Grid>
            )
        }

        {
          !(task && !billableForTask && !disableHorseTaskLookup) && (
            <Box
              sx={{
                mt: 4,
                p: 1,
                border: `1px dashed ${'var(--blueGrey-unknown)'}`,
                borderRadius: 4,
              }}
              style={{ '--blueGrey-unknown': blueGrey[300] }}
            >
              {
                (billable && billable.taskId)
                  ? (
                    <Typography fontWeight={300}>Transactions created from tasks cannot be repeated.
                      Instead, you can setup tasks to repeat.
                    </Typography>
                  )
                  : (
                    <Grid container spacing={2}>
                      <Grid
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        size={12}
                      >
                        <FormControlLabel
                          margin="none"
                          sx={{ margin: 0 }}
                          control={(
                            <Switch
                              disabled={quickBooksReserved}
                              checked={isRepeating}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setRepeatRrule((billable && billable.repeatRrule) || 'RRULE:FREQ=MONTHLY;INTERVAL=1;BYMONTHDAY=1');
                                  if (billable && billable.repeatEndDate && new Date(billable.repeatEndDate).getTime() > new Date().getTime()) {
                                    setRepeatEndDate(billable.repeatEndDate)
                                  } else {
                                    setRepeatEndDate(null)
                                  }
                                } else {
                                  setRepeatRrule(null);
                                  setRepeatEndDate((billable && billable.repeatRrule && moment().startOf('day').toDate()) || null); // If we already had an rrule, we will need to end it by setting date to now
                                }
                              }}
                            />
                          )}
                          size="large"
                          label={(<Typography variant="h5">Repeat Transaction</Typography>)}
                        />
                        {
                          (isRepeating) && (
                            <Typography fontWeight={300} fontSize="14px">{`Transaction Repeats: ${capitalize(rrulestr(repeatRrule).toText())} ${repeatEndDate
                              ? `ending ${moment(repeatEndDate).format('ll')}`
                              : ''}`}
                            </Typography>
                          )
                        }
                      </Grid>
                      {
                        (isRepeating) && (
                          <Grid size={12}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                label="Repeating Transaction End Date"
                                disabled={quickBooksReserved}
                                value={toMomentValue(repeatEndDate)}
                                minDate={toMomentValue(new Date())}
                                onChange={(newValue) => {
                                  setRepeatEndDate(fromPickerValue(newValue));
                                }}
                                onClick={(e) => { e.stopPropagation(); }}
                                slotProps={{
                                  textField: {
                                    onClick: (e) => { e.stopPropagation(); },
                                    disabled: !repeatEndDate,
                                    sx: {
                                      width: 350,
                                      mr: 1,
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>
                        )
                      }
                      {
                        isRepeating && !quickBooksReserved && (
                          <Grid size={12}>
                            <RRuleGenerator
                              value={repeatRrule}
                              onChange={setRepeatRrule}
                              config={{
                                repeat: ['Daily', 'Monthly', 'Weekly', 'Yearly'],
                                // monthly: 'on the',
                                // end: ['Never', 'On date'],
                                weekStartsOnSunday: true,
                                hideStart: true,
                                hideEnd: true,
                              }}
                            />
                          </Grid>
                        )
                      }
                    </Grid>
                  )
              }
            </Box>
          )
        }
        <Divider
          sx={{
            mt: 2,
            mb: 1.5,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: 1,
            px: 2,
          }}
        >
          {(billable && billable.id && !repeatMode && !quickBooksReserved)
            ? (
              <Button
                color="error"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (confirmDelete) { handleDelete(); } else { setConfirmDelete(true); }
                }}
                loading={isLoading}
                variant={confirmDelete
                  ? 'contained'
                  : 'outlined'}
              >{confirmDelete
                ? 'Confirm Delete Transaction'
                : 'Delete Transaction'}
              </Button>
            )
            : (<Box />)}
          <Box>
            {quickBooksReserved
              ? <Button onClick={() => onClose()} variant="outlined">Close</Button>
              : <Button onClick={onSave} disabled={isLoading} variant="contained" color="primary" loading={isLoading} loadingPosition="start" startIcon={<SaveIcon />}>Save</Button>}
          </Box>
        </Box>

        <AddEditInvoiceModalComponent
          open={openAddEditModal}
          onClose={() => { setSelectedInvoice(null); setOpenAddEditModal(false); }}
          invoice={selectedInvoice}
        />
      </DialogActions>
    </Dialog>
  );
};

AddEditBillableModalComponent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  billable: PropTypes.object,
  taskId: PropTypes.number,
  repeatMode: PropTypes.bool,
};

AddEditBillableModalComponent.defaultProps = {
  open: false,
  billable: null,
  taskId: null,
  repeatMode: false,
};

export default (AddEditBillableModalComponent);
